"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getBannerColorValue, getBannerImageUrl } from "@/helpers/profile-banner.helpers";
import UserPageHeaderEditBanner from "./UserPageHeaderEditBanner";
export default function UserPageHeaderBanner(t0) {
  const $ = _c(26);
  const {
    profile,
    defaultBanner1,
    defaultBanner2,
    canEdit
  } = t0;
  const [isEditOpen, setIsEditOpen] = useState(false);
  let t1;
  if ($[0] !== profile.banner1) {
    const bannerImageUrl = getBannerImageUrl(profile.banner1);
    t1 = bannerImageUrl ? getScaledImageUri(bannerImageUrl, ImageScale.AUTOx800) : null;
    $[0] = profile.banner1;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const scaledBannerUrl = t1;
  let t2;
  if ($[2] !== defaultBanner1 || $[3] !== profile.banner1) {
    t2 = getBannerColorValue(profile.banner1) ?? defaultBanner1;
    $[2] = defaultBanner1;
    $[3] = profile.banner1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const banner1Color = t2;
  let t3;
  if ($[5] !== defaultBanner2 || $[6] !== profile.banner2) {
    t3 = getBannerColorValue(profile.banner2) ?? defaultBanner2;
    $[5] = defaultBanner2;
    $[6] = profile.banner2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const banner2Color = t3;
  let t4;
  if ($[8] !== banner1Color || $[9] !== banner2Color || $[10] !== scaledBannerUrl) {
    t4 = scaledBannerUrl ? <div className="tw-absolute tw-inset-0" style={{
      backgroundImage: `url(${scaledBannerUrl})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    }} /> : <div className="tw-absolute tw-inset-0" style={{
      background: `linear-gradient(45deg, ${banner1Color} 0%, ${banner2Color} 100%)`
    }} />;
    $[8] = banner1Color;
    $[9] = banner2Color;
    $[10] = scaledBannerUrl;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-ring-1 tw-ring-inset tw-ring-white/5" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== canEdit) {
    t6 = canEdit && <button onClick={() => setIsEditOpen(true)} className="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-border-none tw-bg-transparent tw-p-0" aria-label="Edit banner"><div className="edit-profile tw-absolute tw-inset-0 tw-bg-black/30"><div className="tw-absolute tw-bottom-4 tw-right-4"><PencilIcon /></div></div></button>;
    $[13] = canEdit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== defaultBanner1 || $[16] !== defaultBanner2 || $[17] !== isEditOpen || $[18] !== profile) {
    t7 = isEditOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageHeaderEditBanner profile={profile} defaultBanner1={defaultBanner1} defaultBanner2={defaultBanner2} onClose={() => setIsEditOpen(false)} /></CommonAnimationOpacity>;
    $[15] = defaultBanner1;
    $[16] = defaultBanner2;
    $[17] = isEditOpen;
    $[18] = profile;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <CommonAnimationWrapper mode="sync" initial={true}>{t7}</CommonAnimationWrapper>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t6 || $[24] !== t8) {
    t9 = <div className="tw-group tw-relative tw-z-10 tw-h-32 tw-w-full tw-overflow-hidden sm:tw-h-48">{t4}{t5}{t6}{t8}</div>;
    $[22] = t4;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(e) {
  return e.stopPropagation();
}